import { Decorable, Dict } from '../decorable';


export enum COMPARESTR {
  NONE = 'select a comparison',
  EQUALS = 'equals',
  EXACTLY_EQUALS = 'exact match',
  NOT_EQUALS = 'does not equal',
  GT = 'is greater than',
  GT_OR_EQUAL = 'is greater than or equal to',
  LT = 'is less than',
  LT_OR_EQUAL = 'is less than or equal to',
  HAS = 'contains',
  NOT_HAS = 'does not contain',
  ISNULL = 'is null or empty',
  NOT_ISNULL = 'is not null or empty',
  IN = 'is in list',
  NOT_IN = 'is not in list',
  ISNAN = 'is not a number',
  NOT_ISNAN = 'is a valid number',
  STARTS = 'starts with',
  ENDS = 'ends with',
  TRUE = 'is true',
  FALSE = 'is false',
  GEOM_NONE = 'select a comparison',
  INTERSECTS = 'intersects records',
  NOT_INTERSECTS = 'does not intersect records',
  CONTAINS = 'encloses records areas',
  NOT_CONTAINS = 'doesn not enclose records areas',
  IN_MEMORY = 'includes records',
  NOT_IN_MEMORY = 'doesn not include records',
  DATE_EQUALS = 'is equal to',
  DATE_NOT_EQUALS = 'is not equal to',
  DATE_BEFORE = 'is before',
  DATE_AFTER = 'is after',
  DATE_BETWEEN = 'is within',
  DATE_NOT_BETWEEN = 'is not within',
  DATE_IS_A = 'is a',
  DATE_IS_NOT_A = 'is not a',
  DATE_IS_ONE_OF = 'is one of',
  DATE_IS_NOT_ONE_OF = 'is not one of'

}

export enum COMPARE {
  NONE = '',
  EQUALS = '==',
  EXACTLY_EQUALS = '===',
  NOT_EQUALS = '<>',
  GT = '>',
  GT_OR_EQUAL = '>=',
  LT = '<',
  LT_OR_EQUAL = '<=',
  HAS = 'contains',
  NOT_HAS = '!contains',
  ISNULL = 'isnull',
  NOT_ISNULL = 'not_isnull',
  ISNAN = 'isnan',
  NOT_ISNAN = '!isnan',
  IN = 'IN',
  NOT_IN = 'NOT IN',
  STARTS = 'starts',
  ENDS = 'ends',
  TRUE = 'true',
  FALSE = 'false',
  GEOM_NONE = 0,
  INTERSECTS = 1,
  NOT_INTERSECTS = -1,
  CONTAINS = 2,
  NOT_CONTAINS = -2,
  IN_MEMORY = 'in',
  NOT_IN_MEMORY = 'not in',
  DATE_EQUALS = 'date-equals',
  DATE_NOT_EQUALS = 'date-not-equals',
  DATE_BEFORE = 'date-before',
  DATE_AFTER = 'date-after',
  DATE_BETWEEN = 'date-between',
  DATE_NOT_BETWEEN = 'date-not-between',
  DATE_IS_A = 'date-is-a',
  DATE_IS_NOT_A = 'date-is-not-a',
  DATE_IS_ONE_OF = 'date-is-one-of',
  DATE_IS_NOT_ONE_OF = 'date-is-not-one-of'
}
export enum COMPARE_KEYS {
  NONE = '',
  EQUALS = 'EQUALS',
  EXACTLY_EQUALS = 'EXACTLY_EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  GT = 'GT',
  GT_OR_EQUAL = 'GT_OR_EQUAL',
  LT = 'LT',
  LT_OR_EQUAL = 'LT_OR_EQUAL',
  HAS = 'HAS',
  NOT_HAS = 'NOT_HAS',
  ISNULL = 'ISNULL',
  NOT_ISNULL = 'NOT_ISNULL',
  ISNAN = 'ISNAN',
  NOT_ISNAN = 'NOT_ISNAN',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  STARTS = 'STARTS',
  ENDS = 'ENDS',
  TRUE = 'TRUE',
  FALSE = 'FALSE',
  GEOM_NONE = 'GEOM_NONE',
  INTERSECTS = 'INTERSECTS',
  NOT_INTERSECTS = 'NOT_INTERSECTS',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  IN_MEMORY = 'IN_MEMORY',
  NOT_IN_MEMORY = 'NOT_IN_MEMORY',
  DATE_EQUALS = 'DATE_EQUALS',
  DATE_NOT_EQUALS = 'DATE_NOT_EQUALS',
  DATE_BEFORE = 'DATE_BEFORE',
  DATE_AFTER = 'DATE_AFTER',
  DATE_BETWEEN = 'DATE_BETWEEN',
  DATE_NOT_BETWEEN = 'DATE_NOT_BETWEEN',
  DATE_IS_A = 'DATE_IS_A',
  DATE_IS_NOT_A = 'DATE_IS_NOT_A',
  DATE_IS_ONE_OF = 'DATE_IS_ONE_OF',
  DATE_IS_NOT_ONE_OF = 'DATE_IS_NOT_ONE_OF'
}

export enum IntersectCompare {
  INTERSECTS = 1,
  NOT_INTERSECTS = -1
}

export enum MemoryCompare {
  IN_MEMORY = 'in',
  NOT_IN_MEMORY = 'not in'
}

export enum OPERATOR {
  AND = ' AND ',
  OR = ' OR ',
  MONGO_AND = '$and',
  MONGO_OR = '$or'
}



export class Comparisons {
  private static compareToKey: Decorable;
  private static anyComparisons: Decorable;
  private static UrlStrLUT: Decorable;
  private static numericComparisons: Decorable;
  private static stringComparisons: Decorable;
  private static booleanComparisons: Decorable;
  private static memoryComparisons: Decorable;
  private static dateComparisons: Decorable;

  static GetCompareKey(key: string): string | number {
    switch (key) {
      case COMPARE_KEYS.NONE:
        return COMPARE.NONE;
      case COMPARE_KEYS.EQUALS:
        return COMPARE.EQUALS;
      case COMPARE_KEYS.EXACTLY_EQUALS:
        return COMPARE.EXACTLY_EQUALS;
      case COMPARE_KEYS.NOT_EQUALS:
        return COMPARE.NOT_EQUALS;
      case COMPARE_KEYS.GT:
        return COMPARE.GT;
      case COMPARE_KEYS.GT_OR_EQUAL:
        return COMPARE.GT_OR_EQUAL;
      case COMPARE_KEYS.LT:
        return COMPARE.LT;
      case COMPARE_KEYS.LT_OR_EQUAL:
        return COMPARE.LT_OR_EQUAL;
      case COMPARE_KEYS.HAS:
        return COMPARE.HAS;
      case COMPARE_KEYS.NOT_HAS:
        return COMPARE.NOT_HAS;
      case COMPARE_KEYS.ISNULL:
        return COMPARE.ISNULL;
      case COMPARE_KEYS.NOT_ISNULL:
        return COMPARE.NOT_ISNULL;
      case COMPARE_KEYS.ISNAN:
        return COMPARE.ISNAN;
      case COMPARE_KEYS.NOT_ISNAN:
        return COMPARE.NOT_ISNAN;
      case COMPARE_KEYS.IN:
        return COMPARE.IN;
      case COMPARE_KEYS.NOT_IN:
        return COMPARE.NOT_IN;
      case COMPARE_KEYS.STARTS:
        return COMPARE.STARTS;
      case COMPARE_KEYS.ENDS:
        return COMPARE.ENDS;
      case COMPARE_KEYS.TRUE:
        return COMPARE.TRUE;
      case COMPARE_KEYS.FALSE:
        return COMPARE.FALSE;
      case COMPARE_KEYS.GEOM_NONE:
        return COMPARE.GEOM_NONE;
      case COMPARE_KEYS.INTERSECTS:
        return COMPARE.INTERSECTS;
      case COMPARE_KEYS.NOT_INTERSECTS:
        return COMPARE.NOT_INTERSECTS;
      case COMPARE_KEYS.CONTAINS:
        return COMPARE.CONTAINS;
      case COMPARE_KEYS.NOT_CONTAINS:
        return COMPARE.NOT_CONTAINS;
      case COMPARE_KEYS.IN_MEMORY:
        return COMPARE.IN_MEMORY;
      case COMPARE_KEYS.NOT_IN_MEMORY:
        return COMPARE.NOT_IN_MEMORY;
      case COMPARE_KEYS.DATE_EQUALS:
        return COMPARE.DATE_EQUALS;
      case COMPARE_KEYS.DATE_NOT_EQUALS:
        return COMPARE.DATE_NOT_EQUALS;
      case COMPARE_KEYS.DATE_BEFORE:
        return COMPARE.DATE_BEFORE;
      case COMPARE_KEYS.DATE_AFTER:
        return COMPARE.DATE_AFTER;
      case COMPARE_KEYS.DATE_BETWEEN:
        return COMPARE.DATE_BETWEEN;
      case COMPARE_KEYS.DATE_NOT_BETWEEN:
        return COMPARE.DATE_NOT_BETWEEN;
      case COMPARE_KEYS.DATE_IS_A:
        return COMPARE.DATE_IS_A;
      case COMPARE_KEYS.DATE_IS_NOT_A:
        return COMPARE.DATE_IS_NOT_A;
      case COMPARE_KEYS.DATE_IS_ONE_OF:
        return COMPARE.DATE_IS_ONE_OF;
      case COMPARE_KEYS.DATE_IS_NOT_ONE_OF:
        return COMPARE.DATE_IS_NOT_ONE_OF;
    }
  }

  static GetComparisonToKey(): Dict {
    if (Comparisons.compareToKey !== undefined) {
      return Comparisons.compareToKey as Dict;
    }
    Comparisons.compareToKey = {};
    Comparisons.compareToKey[COMPARE.NONE] = COMPARE_KEYS.NONE;
    Comparisons.compareToKey[COMPARE.EQUALS] = COMPARE_KEYS.EQUALS;
    Comparisons.compareToKey[COMPARE.EXACTLY_EQUALS] = COMPARE_KEYS.EXACTLY_EQUALS;
    Comparisons.compareToKey[COMPARE.NOT_EQUALS] = COMPARE_KEYS.NOT_EQUALS;
    Comparisons.compareToKey[COMPARE.GT] = COMPARE_KEYS.GT;
    Comparisons.compareToKey[COMPARE.GT_OR_EQUAL] = COMPARE_KEYS.GT_OR_EQUAL;
    Comparisons.compareToKey[COMPARE.LT] = COMPARE_KEYS.LT;
    Comparisons.compareToKey[COMPARE.LT_OR_EQUAL] = COMPARE_KEYS.LT_OR_EQUAL;
    Comparisons.compareToKey[COMPARE.HAS] = COMPARE_KEYS.HAS;
    Comparisons.compareToKey[COMPARE.NOT_HAS] = COMPARE_KEYS.NOT_HAS;
    Comparisons.compareToKey[COMPARE.ISNULL] = COMPARE_KEYS.ISNULL;
    Comparisons.compareToKey[COMPARE.NOT_ISNULL] = COMPARE_KEYS.NOT_ISNULL;
    Comparisons.compareToKey[COMPARE.ISNAN] = COMPARE_KEYS.ISNAN;
    Comparisons.compareToKey[COMPARE.NOT_ISNAN] = COMPARE_KEYS.NOT_ISNAN;
    Comparisons.compareToKey[COMPARE.IN] = COMPARE_KEYS.IN;
    Comparisons.compareToKey[COMPARE.NOT_IN] = COMPARE_KEYS.NOT_IN;
    Comparisons.compareToKey[COMPARE.STARTS] = COMPARE_KEYS.STARTS;
    Comparisons.compareToKey[COMPARE.ENDS] = COMPARE_KEYS.ENDS;
    Comparisons.compareToKey[COMPARE.TRUE] = COMPARE_KEYS.TRUE;
    Comparisons.compareToKey[COMPARE.FALSE] = COMPARE_KEYS.FALSE;
    Comparisons.compareToKey[COMPARE.GEOM_NONE] = COMPARE_KEYS.GEOM_NONE;
    Comparisons.compareToKey[COMPARE.INTERSECTS] = COMPARE_KEYS.INTERSECTS;
    Comparisons.compareToKey[COMPARE.NOT_INTERSECTS] = COMPARE_KEYS.NOT_INTERSECTS;
    Comparisons.compareToKey[COMPARE.CONTAINS] = COMPARE_KEYS.CONTAINS;
    Comparisons.compareToKey[COMPARE.NOT_CONTAINS] = COMPARE_KEYS.NOT_CONTAINS;
    Comparisons.compareToKey[COMPARE.IN_MEMORY] = COMPARE_KEYS.IN_MEMORY;
    Comparisons.compareToKey[COMPARE.NOT_IN_MEMORY] = COMPARE_KEYS.NOT_IN_MEMORY;
    Comparisons.compareToKey[COMPARE.DATE_EQUALS] = COMPARE_KEYS.DATE_EQUALS;
    Comparisons.compareToKey[COMPARE.DATE_NOT_EQUALS] = COMPARE_KEYS.DATE_NOT_EQUALS;
    Comparisons.compareToKey[COMPARE.DATE_BEFORE] = COMPARE_KEYS.DATE_BEFORE;
    Comparisons.compareToKey[COMPARE.DATE_AFTER] = COMPARE_KEYS.DATE_AFTER;
    Comparisons.compareToKey[COMPARE.DATE_BETWEEN] = COMPARE_KEYS.DATE_BETWEEN;
    Comparisons.compareToKey[COMPARE.DATE_NOT_BETWEEN] = COMPARE_KEYS.DATE_NOT_BETWEEN;
    Comparisons.compareToKey[COMPARE.DATE_IS_A] = COMPARE_KEYS.DATE_IS_A;
    Comparisons.compareToKey[COMPARE.DATE_IS_NOT_A] = COMPARE_KEYS.DATE_IS_NOT_A;
    Comparisons.compareToKey[COMPARE.DATE_IS_ONE_OF] = COMPARE_KEYS.DATE_IS_ONE_OF;
    Comparisons.compareToKey[COMPARE.DATE_IS_NOT_ONE_OF] = COMPARE_KEYS.DATE_IS_NOT_ONE_OF;
    return Comparisons.compareToKey;

  }
  static GetKeys(items: Dict): Array<string> {
    const keys = [];
    for (const key in items) {
      if (items.hasOwnProperty(key)) {
        keys.push(key);
      }
    }
    return keys;
  }


  static GetAny(): Dict {
    if (Comparisons.anyComparisons !== undefined) {
      return Comparisons.anyComparisons as Dict;
    }
    Comparisons.anyComparisons = {};
    Comparisons.anyComparisons[COMPARESTR.NONE] = COMPARE.NONE;
    Comparisons.anyComparisons[COMPARESTR.EQUALS] = COMPARE.EQUALS;
    Comparisons.anyComparisons[COMPARESTR.EXACTLY_EQUALS] = COMPARE.EXACTLY_EQUALS;
    Comparisons.anyComparisons[COMPARESTR.NOT_EQUALS] = COMPARE.NOT_EQUALS;
    Comparisons.anyComparisons[COMPARESTR.GT] = COMPARE.GT;
    Comparisons.anyComparisons[COMPARESTR.GT_OR_EQUAL] = COMPARE.GT_OR_EQUAL;
    Comparisons.anyComparisons[COMPARESTR.LT] = COMPARE.LT;
    Comparisons.anyComparisons[COMPARESTR.LT_OR_EQUAL] = COMPARE.LT_OR_EQUAL;
    Comparisons.anyComparisons[COMPARESTR.HAS] = COMPARE.HAS;
    Comparisons.anyComparisons[COMPARESTR.NOT_HAS] = COMPARE.NOT_HAS;
    Comparisons.anyComparisons[COMPARESTR.ISNULL] = COMPARE.ISNULL;
    Comparisons.anyComparisons[COMPARESTR.NOT_ISNULL] = COMPARE.NOT_ISNULL;
    Comparisons.anyComparisons[COMPARESTR.IN] = COMPARE.IN;
    Comparisons.anyComparisons[COMPARESTR.NOT_IN] = COMPARE.NOT_IN;
    Comparisons.anyComparisons[COMPARESTR.ISNAN] = COMPARE.ISNAN;
    Comparisons.anyComparisons[COMPARESTR.NOT_ISNAN] = COMPARE.NOT_ISNAN;
    Comparisons.anyComparisons[COMPARESTR.STARTS] = COMPARE.STARTS;
    Comparisons.anyComparisons[COMPARESTR.ENDS] = COMPARE.ENDS;
    Comparisons.anyComparisons[COMPARESTR.TRUE] = COMPARE.TRUE;
    Comparisons.anyComparisons[COMPARESTR.FALSE] = COMPARE.FALSE;
    return Comparisons.anyComparisons as Dict;
  }


  static GetNumeric(): Dict {
    if (Comparisons.numericComparisons !== undefined) {
      return Comparisons.numericComparisons as Dict;
    }
    Comparisons.numericComparisons = {};
    Comparisons.numericComparisons[COMPARESTR.NONE] = COMPARE.NONE;
    Comparisons.numericComparisons[COMPARESTR.EQUALS] = COMPARE.EQUALS;
    Comparisons.numericComparisons[COMPARESTR.EXACTLY_EQUALS] = COMPARE.EXACTLY_EQUALS;
    Comparisons.numericComparisons[COMPARESTR.NOT_EQUALS] = COMPARE.NOT_EQUALS;
    Comparisons.numericComparisons[COMPARESTR.LT] = COMPARE.LT;
    Comparisons.numericComparisons[COMPARESTR.LT_OR_EQUAL] = COMPARE.LT_OR_EQUAL;
    Comparisons.numericComparisons[COMPARESTR.EXACTLY_EQUALS] = COMPARE.EXACTLY_EQUALS;
    Comparisons.numericComparisons[COMPARESTR.GT] = COMPARE.GT;
    Comparisons.numericComparisons[COMPARESTR.GT_OR_EQUAL] = COMPARE.GT_OR_EQUAL;
    Comparisons.numericComparisons[COMPARESTR.ISNAN] = COMPARE.ISNAN;
    Comparisons.numericComparisons[COMPARESTR.NOT_ISNAN] = COMPARE.NOT_ISNAN;
    Comparisons.numericComparisons[COMPARESTR.HAS] = COMPARE.HAS;
    Comparisons.numericComparisons[COMPARESTR.NOT_HAS] = COMPARE.NOT_HAS;
    Comparisons.numericComparisons[COMPARESTR.STARTS] = COMPARE.STARTS;
    Comparisons.numericComparisons[COMPARESTR.ENDS] = COMPARE.ENDS;
    Comparisons.anyComparisons[COMPARESTR.IN] = COMPARE.IN;
    Comparisons.anyComparisons[COMPARESTR.NOT_IN] = COMPARE.NOT_IN;
    return Comparisons.numericComparisons as Dict;
  }

  static GetString(): Dict {
    if (Comparisons.stringComparisons !== undefined) {
      return Comparisons.stringComparisons as Dict;
    }
    Comparisons.stringComparisons = {};
    Comparisons.stringComparisons[COMPARESTR.NONE] = COMPARE.NONE;
    Comparisons.stringComparisons[COMPARESTR.EQUALS] = COMPARE.EQUALS;
    Comparisons.stringComparisons[COMPARESTR.EXACTLY_EQUALS] = COMPARE.EXACTLY_EQUALS;
    Comparisons.stringComparisons[COMPARESTR.NOT_EQUALS] = COMPARE.NOT_EQUALS;
    Comparisons.stringComparisons[COMPARESTR.HAS] = COMPARE.HAS;
    Comparisons.stringComparisons[COMPARESTR.NOT_HAS] = COMPARE.NOT_HAS;
    Comparisons.stringComparisons[COMPARESTR.ISNULL] = COMPARE.ISNULL;
    Comparisons.stringComparisons[COMPARESTR.NOT_ISNULL] = COMPARE.NOT_ISNULL;
    Comparisons.stringComparisons[COMPARESTR.IN] = COMPARE.IN;
    Comparisons.stringComparisons[COMPARESTR.NOT_IN] = COMPARE.NOT_IN;
    Comparisons.stringComparisons[COMPARESTR.STARTS] = COMPARE.STARTS;
    Comparisons.stringComparisons[COMPARESTR.ENDS] = COMPARE.ENDS;
    return Comparisons.stringComparisons as Dict;
  }

  static GetBoolean(): Dict {
    if (Comparisons.booleanComparisons !== undefined) {
      return Comparisons.booleanComparisons as Dict;
    }
    Comparisons.booleanComparisons = {};
    Comparisons.booleanComparisons[COMPARESTR.TRUE] = COMPARE.TRUE;
    Comparisons.booleanComparisons[COMPARESTR.FALSE] = COMPARE.FALSE;
    return Comparisons.booleanComparisons as Dict;
  }

  static GetMemory(): Dict {
    if (Comparisons.memoryComparisons !== undefined) {
      return Comparisons.memoryComparisons as Dict;
    }
    Comparisons.memoryComparisons = {};
    Comparisons.memoryComparisons[COMPARESTR.GEOM_NONE] = COMPARE.GEOM_NONE;
    Comparisons.memoryComparisons[COMPARESTR.IN_MEMORY] = COMPARE.IN_MEMORY;
    Comparisons.memoryComparisons[COMPARESTR.NOT_IN_MEMORY] = COMPARE.NOT_IN_MEMORY;
    Comparisons.memoryComparisons[COMPARESTR.INTERSECTS] = COMPARE.INTERSECTS;
    Comparisons.memoryComparisons[COMPARESTR.NOT_INTERSECTS] = COMPARE.NOT_INTERSECTS;
    Comparisons.memoryComparisons[COMPARESTR.CONTAINS] = COMPARE.CONTAINS;
    Comparisons.memoryComparisons[COMPARESTR.NOT_CONTAINS] = COMPARE.NOT_CONTAINS;
    return Comparisons.memoryComparisons as Dict;
  }
  static GetDate(): Dict {
    if (Comparisons.dateComparisons !== undefined) {
      return Comparisons.dateComparisons as Dict;
    }
    Comparisons.dateComparisons = {};
    Comparisons.dateComparisons[COMPARESTR.DATE_EQUALS] = COMPARE.DATE_EQUALS;
    Comparisons.dateComparisons[COMPARESTR.DATE_NOT_EQUALS] = COMPARE.DATE_NOT_EQUALS;
    Comparisons.dateComparisons[COMPARESTR.DATE_BEFORE] = COMPARE.DATE_BEFORE;
    Comparisons.dateComparisons[COMPARESTR.DATE_AFTER] = COMPARE.DATE_AFTER;
    Comparisons.dateComparisons[COMPARESTR.DATE_BETWEEN] = COMPARE.DATE_BETWEEN;
    Comparisons.dateComparisons[COMPARESTR.DATE_NOT_BETWEEN] = COMPARE.DATE_NOT_BETWEEN;
    Comparisons.dateComparisons[COMPARESTR.DATE_IS_A] = COMPARE.DATE_IS_A;
    Comparisons.dateComparisons[COMPARESTR.DATE_IS_NOT_A] = COMPARE.DATE_IS_NOT_A;
    Comparisons.dateComparisons[COMPARESTR.DATE_IS_ONE_OF] = COMPARE.DATE_IS_ONE_OF;
    Comparisons.dateComparisons[COMPARESTR.DATE_IS_NOT_ONE_OF] = COMPARE.DATE_IS_NOT_ONE_OF;

    return Comparisons.dateComparisons
  }
  static Destroy() {
    delete Comparisons.anyComparisons;
    delete Comparisons.numericComparisons;
    delete Comparisons.stringComparisons;
    delete Comparisons.booleanComparisons;
    delete Comparisons.memoryComparisons;
  }

}
